const initialValues = {
  parent: "",
  orgname: "",
  id: undefined,
  logoURL: ""
};

export { initialValues };
